import type { MenuStore } from '@layers/web/stores/types/menu.ts'

const useMenuStore = defineStore('menu', {
  state: (): MenuStore => ({
    sideMenuActive: false,
    alertHidden: false,
    hamburgerMenuActive: false,
    loadingMenu: false,
  }),
  getters: {},
  actions: {
    toggleSideMenuActive () {
      this.sideMenuActive = !this.sideMenuActive
      this.hamburgerMenuActive = false
    },

    closeSideMenuActive () {
      this.hamburgerMenuActive = false
      this.sideMenuActive = false
    },

    SET_ALERT_HIDDEN (hidden: boolean) {
      this.alertHidden = hidden
    },

    SET_MENU_LOADING (loading: boolean) {
      this.loadingMenu = loading
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useMenuStore, import.meta.hot))
}

export { useMenuStore }